import React from 'react';

const UpgradeNudgePaths = () => (
  <svg fill="none" width="100%" xmlns="http://www.w3.org/2000/svg">
    <g filter="url(#filter0_d)">
      <path
        d="M10 15C10 9.47715 14.4772 5 20 5H480C485.523 5 490 9.47715 490 15V92C490 97.5228 485.523 102 480 102H20C14.4771 102 10 97.5228 10 92V15Z"
        fill="white"
      />
    </g>
    <rect
      fill="#F2F2F2"
      height="25"
      rx="5"
      transform="matrix(1 0 0 -1 110 80)"
      width="260"
    />
    <path
      d="M40 40C40 34.4772 44.4772 30 50 30H80C85.5228 30 90 34.4772 90 40V70C90 75.5228 85.5228 80 80 80H50C44.4772 80 40 75.5228 40 70V40Z"
      fill="#E52F00"
    />
    <path
      d="M68.7906 64L67.8765 60.5215H61.8463L60.9068 64H55.3971L61.4527 45.3633H68.1432L74.275 64H68.7906ZM66.8355 56.4082L66.0357 53.3613C65.8495 52.6842 65.621 51.8083 65.3502 50.7334C65.0878 49.6585 64.9143 48.8883 64.8297 48.4229C64.7535 48.8545 64.6012 49.5654 64.3726 50.5557C64.1526 51.5459 63.6575 53.4967 62.8873 56.4082H66.8355Z"
      fill="white"
      opacity="0.5"
    />
    <rect fill="#F2F2F2" height="15" rx="2" width="130" x="110" y="30" />
    <g filter="url(#filter1_d)">
      <path
        d="M10 132C10 126.477 14.4772 122 20 122H480C485.523 122 490 126.477 490 132V209C490 214.523 485.523 219 480 219H20C14.4771 219 10 214.523 10 209V132Z"
        fill="white"
      />
    </g>
    <rect
      fill="#F2F2F2"
      height="25"
      rx="5"
      transform="matrix(1 0 0 -1 110 197)"
      width="260"
    />
    <path
      d="M40 157C40 151.477 44.4772 147 50 147H80C85.5228 147 90 151.477 90 157V187C90 192.523 85.5228 197 80 197H50C44.4772 197 40 192.523 40 187V157Z"
      fill="#2655BD"
    />
    <path
      d="M58.0885 162.439H64.5631C67.0852 162.439 68.9557 162.816 70.1744 163.569C71.4016 164.314 72.0152 165.478 72.0152 167.061C72.0152 168.102 71.7486 168.99 71.2154 169.727C70.6822 170.463 69.9797 170.937 69.108 171.148V171.275C70.259 171.58 71.0927 172.088 71.609 172.799C72.1252 173.51 72.3834 174.432 72.3834 175.566C72.3834 177.251 71.7486 178.579 70.4791 179.553C69.218 180.518 67.4957 181 65.3121 181H58.0885V162.439ZM63.1031 169.562H64.6139C65.3333 169.562 65.8876 169.413 66.2769 169.117C66.6747 168.821 66.8736 168.381 66.8736 167.797C66.8736 166.756 66.0865 166.235 64.5123 166.235H63.1031V169.562ZM63.1031 173.23V177.128H64.8678C66.4335 177.128 67.2164 176.468 67.2164 175.147C67.2164 174.53 67.0048 174.056 66.5816 173.726C66.1669 173.396 65.5618 173.23 64.7662 173.23H63.1031Z"
      fill="white"
      opacity="0.5"
    />
    <rect fill="#F2F2F2" height="15" rx="2" width="130" x="110" y="147" />
    <defs>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="117"
        id="filter0_d"
        width="500"
        x="0"
        y="0"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
      <filter
        colorInterpolationFilters="sRGB"
        filterUnits="userSpaceOnUse"
        height="117"
        id="filter1_d"
        width="500"
        x="0"
        y="117"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
        />
        <feOffset dy="5" />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          in2="BackgroundImageFix"
          mode="normal"
          result="effect1_dropShadow"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow"
          mode="normal"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default UpgradeNudgePaths;
